"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.setHeaders = setHeaders;
exports.setBaseURL = setBaseURL;
exports.saga = saga;
exports.performRequest = performRequest;
exports.reload = exports.client = exports.ACTIONS = void 0;

var _effects = require("redux-saga/effects");

var _axios = _interopRequireDefault(require("axios"));

var qs = _interopRequireWildcard(require("qs"));

var _lodash = require("lodash");

var _index = require("./index");

var _auth = require("./auth");

var _localConfigs = require("./localConfigs");

var _errors = require("./errors");

var _utils = require("../utils");

var _settings = require("../settings");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleRequest),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(saga);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTIONS = {
  REQUEST_STARTED: new _index.Action('REQUEST_STARTED'),
  REQUEST_FINISHED: new _index.Action('REQUEST_FINISHED'),
  API_IS_OFFLINE: new _index.Action('API_IS_OFFLINE'),
  RELOAD: new _index.Action('RELOAD')
};
exports.ACTIONS = ACTIONS;
var initialState = {
  pendingRequests: 0,
  isLoading: false,
  isOffline: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case ACTIONS.REQUEST_STARTED.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.REQUEST_FINISHED.main:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0,
        isOffline: false
      });

    case ACTIONS.API_IS_OFFLINE.main:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOffline: true
      });

    default:
      return state;
  }
}

var client = _axios["default"].create({
  baseURL: _settings.REACT_APP_API_URL,
  responseType: 'json',
  paramsSerializer: function paramsSerializer(params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false,
      skipNulls: true
    });
  }
});

exports.client = client;
client.interceptors.request.use(function (config) {
  // store.dispatch({type: ACTIONS.REQUEST_STARTED.main})
  return config;
}, function (error) {
  return Promise.reject(error);
});
client.interceptors.response.use(function (response) {
  // store.dispatch({type: ACTIONS.REQUEST_FINISHED.main})
  return response;
}, function (error) {
  // store.dispatch({type: ACTIONS.REQUEST_FINISHED.main})
  return Promise.reject(error);
});

function setHeaders(headers) {
  (0, _lodash.forEach)(headers, function (value, name) {
    client.defaults.headers.common[name] = value;
  });
}

function setBaseURL(baseURL) {
  client.defaults.baseURL = baseURL;
}

function handleReload() {
  console.log('Reloading...');
}

function urlNeedsEntityID(url) {
  var noEntityURLs = ['/auth/token/refresh/', '/entities/', '/entity-profiles/', '/terms/', '/terms-responses/'];
  return (0, _lodash.indexOf)(noEntityURLs, url) === -1;
}

function handleRequest(action) {
  var type, request, meta, url, method, data, followPagination, overwriteData, includeEntityID, headers, params, userToken, entityID, language, response, newRequest;
  return regeneratorRuntime.wrap(function handleRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          type = action.type, request = action.payload.request, meta = action.meta;
          url = request.url;
          method = request.method ? request.method : 'GET';
          data = request.data ? (0, _utils.removeEmptyStrings)(request.data) : null;
          followPagination = request.followPagination ? true : false;
          overwriteData = request.overwriteData ? true : false;
          includeEntityID = request.includeEntityID ? true : false;
          headers = request.headers ? request.headers : {};
          params = request.params ? request.params : {};
          _context.next = 11;
          return (0, _effects.select)(function (state) {
            var _state$users;

            return (_state$users = state.users) === null || _state$users === void 0 ? void 0 : _state$users.token;
          });

        case 11:
          userToken = _context.sent;
          _context.next = 14;
          return (0, _effects.select)(function (state) {
            var _state$localConfigs;

            return (_state$localConfigs = state.localConfigs) === null || _state$localConfigs === void 0 ? void 0 : _state$localConfigs.selectedEntityID;
          });

        case 14:
          entityID = _context.sent;
          _context.next = 17;
          return (0, _effects.select)(function (state) {
            var _state$localConfigs2;

            return (_state$localConfigs2 = state.localConfigs) === null || _state$localConfigs2 === void 0 ? void 0 : _state$localConfigs2.selectedLanguage;
          });

        case 17:
          language = _context.sent;

          if (!userToken) {
            _context.next = 29;
            break;
          }

          client.defaults.headers['Authorization'] = "Bearer ".concat(userToken);
          client.defaults.headers['Entity-ID'] = entityID || '';
          client.defaults.headers['Accept-Language'] = language || '';

          if (!(!entityID && urlNeedsEntityID(url))) {
            _context.next = 28;
            break;
          }

          _context.next = 25;
          return (0, _effects.put)((0, _localConfigs.handleNoSelectedEntity)());

        case 25:
          return _context.abrupt("return", null);

        case 28:
          if (entityID && includeEntityID) {
            params = _objectSpread(_objectSpread({}, params), {}, {
              entity_id: entityID
            });
          }

        case 29:
          _context.prev = 29;
          _context.next = 32;
          return (0, _effects.call)(client, url, {
            params: params,
            method: method,
            data: data,
            headers: headers
          });

        case 32:
          response = _context.sent;
          _context.next = 35;
          return (0, _effects.put)({
            type: type + _index.SUCCESS_SUFFIX,
            payload: response.data,
            overwriteData: overwriteData,
            meta: meta
          });

        case 35:
          if (!(followPagination && (0, _utils.shouldFollowPagination)(response.data))) {
            _context.next = 40;
            break;
          }

          newRequest = _objectSpread({}, request);
          request.params.page = response.data.pages.next;
          _context.next = 40;
          return (0, _effects.put)({
            type: type,
            payload: {
              request: newRequest
            },
            meta: meta
          });

        case 40:
          _context.next = 67;
          break;

        case 42:
          _context.prev = 42;
          _context.t0 = _context["catch"](29);
          console.log('API error', _context.t0);

          if (_context.t0.response) {
            _context.next = 51;
            break;
          }

          console.log('It should be a network error.');
          _context.next = 49;
          return (0, _effects.put)({
            type: ACTIONS.API_IS_OFFLINE.main,
            meta: meta
          });

        case 49:
          _context.next = 67;
          break;

        case 51:
          _context.next = 53;
          return (0, _effects.put)({
            type: type + _index.ERROR_SUFFIX,
            payload: _context.t0.response.data,
            meta: meta
          });

        case 53:
          if (!(_context.t0.response.status === 401)) {
            _context.next = 56;
            break;
          }

          _context.next = 56;
          return (0, _auth.handleUserUnauthenticated)();

        case 56:
          if (!(_context.t0.response.status === 403)) {
            _context.next = 59;
            break;
          }

          _context.next = 59;
          return (0, _errors.handleErrorForbidden)();

        case 59:
          if (!(0, _lodash.startsWith)(_context.t0.response.status, 5)) {
            _context.next = 67;
            break;
          }

          if (!(_context.t0.response.status === 503)) {
            _context.next = 65;
            break;
          }

          _context.next = 63;
          return (0, _errors.handleErrorToolUnavailable)();

        case 63:
          _context.next = 67;
          break;

        case 65:
          _context.next = 67;
          return (0, _effects.put)((0, _errors.handleError500)());

        case 67:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[29, 42]]);
}

function saga() {
  return regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(function (action) {
            return (0, _lodash.has)(action.payload, 'request');
          }, handleRequest);

        case 2:
          _context2.next = 4;
          return (0, _effects.takeEvery)(ACTIONS.RELOAD.main, handleReload);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var reload = function reload() {
  return {
    type: ACTIONS.RELOAD.main
  };
};

exports.reload = reload;

function performRequest(_x) {
  return _performRequest.apply(this, arguments);
}

function _performRequest() {
  _performRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
    var request, url, method, data, headers, params, response;
    return regeneratorRuntime.wrap(function _callee$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            request = action.payload.request;
            url = request.url;
            method = request.method ? request.method : 'GET';
            data = request.data ? request.data : null; // const includeEntityID = request.includeEntityID ? true : false

            headers = request.headers ? request.headers : {};
            params = request.params ? request.params : {};
            _context3.prev = 6;
            _context3.next = 9;
            return client.request({
              url: url,
              params: params,
              method: method,
              data: data,
              headers: headers
            });

          case 9:
            response = _context3.sent;
            return _context3.abrupt("return", {
              status: response.status,
              data: response.data,
              errors: null
            });

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](6);
            return _context3.abrupt("return", {
              status: _context3.t0.response.status,
              data: null,
              errors: _context3.t0.response.data
            });

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee, null, [[6, 13]]);
  }));
  return _performRequest.apply(this, arguments);
}